export default [
  {
    path: '/real-estate-developments-settings/insurance-companies/:id/insurance/new',
    name: 'InsuranceCreate',
    component: () => import('pages/real-estate-developments-settings/insurance-companies/insurance/InsuranceForm.vue')
  },
  {
    path: '/real-estate-developments-settings/insurance-companies/:id/insurance/:insuranceId',
    name: 'InsuranceSingle',
    component: () => import(
      'pages/real-estate-developments-settings/insurance-companies/insurance/InsuranceSingle.vue'
    )
  },
  {
    path: '/real-estate-developments-settings/insurance-companies/:id/insurance/:insuranceId/edit',
    name: 'InsuranceEdit',
    component: () => import('pages/real-estate-developments-settings/insurance-companies/insurance/InsuranceForm.vue')
  }
]
